import {
  customElement,
  type TemplateResult,
  state,
  html,
  property,
  css,
  cssManager,
} from '@design.estate/dees-element';
import * as domtools from '@design.estate/dees-domtools';
import { DeesInputBase } from '../dees-input-base/dees-input-base.js';
import * as ibantools from 'ibantools';
import { demoFunc } from './dees-input-iban.demo.js';
import { themeDefaultStyles } from '../../00theme.js';

@customElement('dees-input-iban')
export class DeesInputIban extends DeesInputBase<DeesInputIban> {
  // STATIC
  public static demo = demoFunc;
  public static demoGroups = ['Input'];

  // INSTANCE
  @state()
  accessor enteredString: string = '';

  @state()
  accessor enteredIbanIsValid: boolean = false;

  @property({
    type: String,
  })
  accessor value = '';

  public static styles = [
    themeDefaultStyles,
    ...DeesInputBase.baseStyles,
    cssManager.defaultStyles,
    css`
      /* TODO: Migrate hardcoded values to --dees-* CSS variables */
      /* IBAN input specific styles can go here */
    `,
  ];

  public render(): TemplateResult {
    return html`
      <div class="input-wrapper">
        <dees-label .label=${this.label || 'IBAN'} .infoText=${this.infoText} .required=${this.required}></dees-label>
        <dees-input-text
          class="input-container"
          .label=${this.label || 'IBAN'}
          labelPosition="none"
          .value=${this.value}
          .disabled=${this.disabled}
          .required=${this.required}
          .placeholder=${'DE89 3704 0044 0532 0130 00'}
          .validationFunction=${(value: string) => {
            const normalized = value.replace(/ /g, '');
            if (normalized.length === 0) {
              return { valid: true, message: '' };
            }
            const isValid = ibantools.isValidIBAN(normalized);
            return isValid
              ? { valid: true, message: 'IBAN is valid' }
              : { valid: false, message: 'Please enter a valid IBAN' };
          }}
          @input=${(eventArg: InputEvent) => {
            this.validateIban(eventArg);
          }}
        ></dees-input-text>
        ${this.renderDescription()}
      </div>
    `;
  }

  public async validateIban(eventArg: InputEvent): Promise<void> {
    const inputElement = eventArg.composedPath()[0];
    if (!(inputElement instanceof HTMLInputElement) || eventArg.isComposing || this.disabled) return;
    let enteredString = inputElement?.value;
    enteredString = enteredString || '';
    if (this.enteredString !== enteredString) {
      this.enteredString = ibantools.friendlyFormatIBAN(enteredString) || '';
      if (inputElement) {
        inputElement.value = this.enteredString;
        this.value = this.enteredString;
        this.changeSubject.next(this);
      }
    }
    this.enteredIbanIsValid = ibantools.isValidIBAN(this.enteredString.replace(/ /g, ''));
  }

  public getValue(): string {
    return this.value;
  }

  public setValue(value: string): void {
    this.value = value;
    this.enteredString = ibantools.friendlyFormatIBAN(value) || '';
  }
}
